import React, { useMemo } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Inicio from './pages/inicio';
import Productos from './pages/productos';
import Beneficios from './pages/beneficios';
import Contacto from './pages/contacto';
import Recetas from './pages/opiniones';
import Galeria from './pages/galeria';
import './App.css';
import './styles/global.css';
import FloatingWhatsAppButton from './utils/FloatingWhatsAppButton';
import Footer from './components/Footer';
import { LanguageProvider, useLanguage } from './context/LanguageContext';
import QuickSettings from './components/QuickSettings';

function AppShell() {
  const { themeMode } = useLanguage();

  const theme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: themeMode,
          primary: { main: '#0f5d53' },
          secondary: { main: '#f2a65a' },
          background:
            themeMode === 'dark'
              ? { default: '#0f1518', paper: '#192126' }
              : { default: '#f4f0e8', paper: '#fffdf8' },
          text:
            themeMode === 'dark'
              ? { primary: '#e8f1ec' }
              : { primary: '#1f2421' }
        },
        shape: {
          borderRadius: 16
        },
        typography: {
          fontFamily: '"Sora", "Segoe UI", sans-serif',
          h1: {
            fontFamily: '"DM Serif Display", serif'
          },
          h2: {
            fontFamily: '"DM Serif Display", serif'
          },
          h3: {
            fontFamily: '"DM Serif Display", serif'
          }
        },
        components: {
          MuiButton: {
            styleOverrides: {
              root: {
                borderRadius: 999,
                textTransform: 'none',
                fontWeight: 700
              }
            }
          }
        }
      }),
    [themeMode]
  );

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <div className="App">
          <main className="app-main">
            <Routes>
              <Route path="/" element={<Inicio />} />
              <Route path="/inicio" element={<Inicio />} />
              <Route path="/beneficios" element={<Beneficios />} />
              <Route path="/productos" element={<Productos />} />
              <Route path="/contacto" element={<Contacto />} />
              <Route path="/recetas" element={<Recetas />} />
              <Route path="/galeria" element={<Galeria />} />
            </Routes>
          </main>
          <QuickSettings />
          <FloatingWhatsAppButton />
          <Footer />
        </div>
      </Router>
    </ThemeProvider>
  );
}

function App() {
  return (
    <LanguageProvider>
      <AppShell />
    </LanguageProvider>
  );
}

export default App;
